/*
 *   File : chip.js
 *   Author : https://evoqins.com
 *   Description :  chip component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

function Chip(props) {
    return (
        props.type === 2 ?
            <span className={`${props.className} e-font-12 px-2 e-border-radius-18 e-primary-font-inter e-font-weight-500 line-height-16px`}>
                {props.name}
            </span>
            :
            <span className={`${props.className} e-border-radius-24 border-1-all border-color-egyptian-blue e-text-egyptian-blue e-alt-font-poppins e-font-weight-400 line-height-18px`}>
                {props.name}
            </span>
    );
};

export default memo(Chip);